import React from 'react';
import Switch from "react-switch";
import Modal from 'react-responsive-modal';
import { ScaleLoader } from 'react-spinners';
import TsSprintDetailItem from './TsSprintDetailItem.jsx';
import TsSwitchableBlock from './TsSwitchableBlock.jsx';

class TsSprintDetail extends React.Component {
	constructor(props) {
		super(props);

		// On ajoute les infos du sprint au state
		this.state = {
            sprintInfo: false,
            open: true,
            cards: {},
            cardsWithDueDate: {},
        };
	}

	// Si le composant va être utilisé
	componentWillMount() {
		// On appelle la fonction qui permet de récupérer le détail du sprint
        this.updateSprintDetailInfo(this.props);
	}

	// Permet de mettre à jour le State cards
	updateCardsState(data, elem) {
        setTimeout(() => {
            elem.setState({
                cards: data.cards,
                cardsWithDueDate: data.cardsWithDueDate,
            });
        }, 300);
    }
    
    // Si le composant va recevoir des props
    componentWillReceiveProps(nextProps) {
        // On appelle la fonction qui permet de récupérer le détail du sprint
        this.updateSprintDetailInfo(nextProps);
    }

    // Fonction permettant de récupérer le détail du sprint
    updateSprintDetailInfo(usedProps) {
        this.setState(
            {
                sprintInfo: this.getSprintInfo(usedProps),
                open: true,
            },
            () => {
                // On appelle la fonction pour update les cartes
		        this.updateCardsFromListAPI(this.updateCardsState, this);
            }
        );
    }

    // Permet de récupérer les infos du sprint
    getSprintInfo(usedProps) {
		// On instancie une variable qui va contenir les infos du sprint
		let sprintInfo = false;

		// On parcourt les sprints
		for (const key in usedProps.sprintsInfo) {
			if (usedProps.sprintsInfo.hasOwnProperty(key)) {
				// On récupère le sprint courant
				const element = usedProps.sprintsInfo[key];
				
				// Si le numéro du sprint courant est le même que celui de l'url
				if (element.number == usedProps.match.params.sprintNumber) {
					// On récupère le sprint courant
                    sprintInfo = element;
                    break;
				}
			}
        }
        
        return sprintInfo;
    }

	// Fonction permettant de mettre à jour les infos de streamer
	updateCardsFromListAPI(callback, elem) {
		// On lance la requête pour récupérer les infos des streamers depuis leur pseudo
		fetch(
			'https://api.trello.com/1/lists/' + elem.state.sprintInfo.apiId + '/cards?key=e0edc2f7a3f1efc4115084c573964b8c&token=6392d59c2cfbb640baeb86ff97cd20a4d39c38149cde8050638ec8fae7cd75eb&fields=id,name,labels,due,dueComplete,idMembers',
			{
				methode: 'GET'
			}
		)
		.then((results) => {
			return results.json();
		})
		.then((data) => {
			// On instancie un objet qui va contenir les cartes triées
            let objCards = {};
            
			// On instancie un objet qui va contenir les cartes triées qui contiennent une date limite
			let objCardsWithDueDate = {};

			// On parcourt les cartes retournées par l'API
			data.map((card) => {
				// On vérifie que la carte fait partie des micros
				if (elem.state.sprintInfo.cardsId.indexOf(card.id) >= 0) {
					// On ajoute la carte à notre tableau global
                    objCards[card.id] = card;
                    
                    // Si la carte à une date limite
                    if (card.due !== null) {
                        objCardsWithDueDate[card.id] = card;
                    }
				}
			});

			// On appelle le callback passé en paramètre
			callback({
                cards: objCards,
                cardsWithDueDate: objCardsWithDueDate,
             }, elem);
		});
	}

	// Permet de fermer la modale
	onModalClose() {
		// alert('api Id : ' + apiId);
		history.pushState(
			{},
			'',
			'/sprints'
		);

		this.setState({ 
            open: false,
            cards: {},
            cardsWithDueDate: {},
		});
    }

	render () {
        console.log(Object.keys(this.state.cards).length);
		return (
            <Modal 
                open={this.state.open} 
                onClose={this.onModalClose.bind(this)} 
                little={false}
                closeIconSize={16}
                showCloseIcon={false}
                classNames={{
                    'overlay': 'overlay pal',
                    'modal': 'sprintItemModal pan'
                }} >

                <div className="sprintDetailModalContent">
                    <h3 className="proxima-bold ptm pll prl pbm man">
                        Sprint {this.props.match.params.sprintNumber}
                    </h3>

                    {/* Si les cartes ne sont pas chargées */}
                    { Object.keys(this.state.cards).length == 0 &&
                        <div className="txtcenter pam">
                            <ScaleLoader
                                color={'#858383'} 
                                height={14}
                                width={2}
                                loading={Object.keys(this.state.cards).length == 0}
                            />
                        </div>
                    }


                    {/* Si les cartes sont chargées */}
                    { Object.keys(this.state.cards).length > 0 &&
                        <div>
                            <TsSprintDetailItem
                                members={this.props.teamInfo.developpersInfo}
                                img={true}
                                bold={true}
                                aloneKey='emptyDevImg'
                            />

                            <TsSwitchableBlock
                                idLabel='switchableBlockType'
                                textLabel='Afficher les types'
                                checked={true}
                                cards={this.state.cards}
                            >
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Bugs'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^Bug/g}
                                    aloneKey='allBugs'
                                />
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Évolutions'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelNotMatch={/^Bug|^Enquête/g}
                                    aloneKey='allEvols'
                                />
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Enquêtes'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^Enquête/g}
                                    aloneKey='allEnquetes'
                                />
                            </TsSwitchableBlock>

                            <hr />

                            <TsSwitchableBlock
                                idLabel='switchableBlockRegression'
                                textLabel='Afficher les régressions'
                                cards={this.state.cards}
                            >
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Régressions'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^Source de régression/g}
                                    aloneKey='allRegression'
                                />
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Refusé 1x'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^Refusé 1x/g}
                                    aloneKey='allRefuse1x'
                                />
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Refusé 2x'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^Refusé 2x/g}
                                    aloneKey='allRefuse2x'
                                />
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Refusé 3x ou +'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^Refusé 3x ou \+/g}
                                    aloneKey='allRefuse3x'
                                />
                            </TsSwitchableBlock>

                            <hr />

                            <TsSwitchableBlock
                                idLabel='switchableBlockProjects'
                                textLabel='Afficher les projets'
                                cards={this.state.cards}
                            >
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Front'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^Front/g}
                                    aloneKey='allFront'
                                />
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='BO'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^BO/g}
                                    aloneKey='allBO'
                                />
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Admin NN'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^Admin NN/g}
                                    aloneKey='allAdminNN'
                                />
                                <TsSprintDetailItem
                                    members={this.props.teamInfo.developpersInfo}
                                    img={false}
                                    bold={[0]}
                                    title='Application'
                                    cards={this.state.cards}
                                    testBy='labels'
                                    regexLabelMatch={/^Appli mobile/g}
                                    aloneKey='allAppliMobile'
                                />
                            </TsSwitchableBlock>

                            <TsSprintDetailItem
                                members={this.props.teamInfo.testersInfo}
                                img={true}
                                bold={true}
                                aloneKey='emptyTesterImg'
                            />

                            <TsSprintDetailItem
                                members={this.props.teamInfo.testersInfo}
                                img={false}
                                bold={[0]}
                                title='Testées à temps'
                                cards={this.state.cardsWithDueDate}
                                testBy='dueDate'
                                aloneKey='allDueDate'
                                isZeroPercentAllowed={false}
                            />
                        </div>
                    }
                </div>
            </Modal>
		);
	}
}

export default TsSprintDetail;


// WEBPACK FOOTER //
// ./src/js/TsSprintDetail.jsx